import React from 'react';

const SearchIcon = ({ width }) => {
  return (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M22.941 24.4607L16.4075 17.7155V16.7381V16.5904L16.3068 16.4824L15.9338 16.0822L15.684 15.8142L15.4103 16.0577C13.8998 17.4009 11.9424 18.207 9.81469 18.207C5.07323 18.207 1.20837 14.2275 1.20837 9.29102C1.20837 4.35454 5.07323 0.375 9.81469 0.375C14.5561 0.375 18.421 4.35454 18.421 9.29102C18.421 11.5027 17.6377 13.5339 16.3383 15.0977L16.1194 15.361L16.3618 15.6028L16.7487 15.9887L16.8585 16.0983H17.0136H17.9458L24.4787 22.8699L22.941 24.4607ZM3.22186 9.29102C3.22186 13.0452 6.15517 16.0983 9.81469 16.0983C13.4742 16.0983 16.4075 13.0452 16.4075 9.29102C16.4075 5.53682 13.4742 2.48377 9.81469 2.48377C6.15517 2.48377 3.22186 5.53682 3.22186 9.29102Z"
        fill="#CFD8DC"
        stroke="#CFD8DC"
        stroke-width="0.75"
      />
    </svg>
  );
};

export default SearchIcon;
